import getApiUrl from "./getUrl";
import getUrl from "./getUrl";

export async function fetchParams() {
    try {

        const res = await fetch(getUrl()+"/api/params", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include", // Include cookies with the request
        });
        return res
    } catch (err) {
    }
}